export default {
  namespaced: true,
  omnicloud_fr: {
    title: "Omnicloud RF",
    provider: "Provedor",
    provider_section: "Selecione um provedor",
    is_blacklist: "Lista Negra",
    master_account: {
      title: "Conta Master",
      name: "Nome",
      description: "Descrição",
      api_user: "Usuário API",
      api_password: "Senha API",
      api_server: "Servidor API"
    },
    watch_list: {
      title: "Lista",
      name: "Nome",
      comment: "Comentário",
      color: "Cor",
      camera_group: "Grupo de câmeras",
      master_account: "Conta Master",
      enable_schedule_disable: "Programação de desabilitação",
      disable_schedule: "Desabilitar programação",
      notify: "Notificar",
      acknowledge: "Acknowledge",
      face_threshold: "Limite de rosto",
      body_threshold: "Limite de corpo",
      car_threshold: "Limite de carro",
      ignore_events: "Ignorar eventos",
      send_events_to_external_vms: "Enviar eventos para VMS externos",
      active_after: "Ativo após",
      active_before: "Ativo antes",
      disable_schedule_active: "Desabilitar programação ativa",
      disable_schedule_monday: "Desabilitar programação segunda-feira",
      disable_schedule_tuesday: "Desabilitar programação terça-feira",
      disable_schedule_wednesday: "Desabilitar programação quarta-feira",
      disable_schedule_thursday: "Desabilitar programação quinta-feira",
      disable_schedule_friday: "Desabilitar programação sexta-feira",
      disable_schedule_saturday: "Desabilitar programação sábado",
      disable_schedule_sunday: "Desabilitar programação domingo",
      master_account_name: "Nome da conta master",
      default_configuration: "Configuração padrão",
      title_schedule_disable: "Desabilitar programação 00:00 - 00:00",
      info: "Informação",
      reconogition_config: "Configuração de reconhecimento",
      schedule_settings: "Horários de desabilitação",
      type_alarm: "Tipo de alarma",
      successful_creation: "Lista de observação criada com sucesso",
      error_creation: "Erro ao criar lista de observação",
      successful_edit: "Lista de observação editada corretamente",
      error_edit: "Erro ao editar a lista de observação",
      successful_delete: "Lista de observação excluída corretamente",
      error_delete: "Erro ao excluir a lista de observação",
      saving_information: "Guardando informações",
    },
    face: {
      image: "Imagem",
      name: "Nome",
      active: "Ativo",
      comment: "Comentário",
      master_account: "Conta Master",
      watch_list: "Lista de vigilância",
      created_at: "Data de criação",
      updated_at: "Data de atualização",
      title: "Rostos",
      features: "Características",
      already_face_added: "Rosto já adicionado",
      face_added_label: "Adicionado",
      success_adding: "Rosto adicionado corretamente",
      success_updating: "Rosto atualizado corretamente",
      error_saving: "Erro ao guardar as informações",
      success_delete: "Rosto eliminado corretamente",
    },
    camera: {
      title: "Câmeras",
      name: "Nome",
      active: "Ativo",
      comment: "Comentário",
      camera_group: "Grupo de câmeras",
      created_at: "Data de criação",
      updated_at: "Data de atualização",
      refresh: "Atualizar",
      camera: "Câmera",
      status: "Status",
    },
    face_search: {
      title: "Pesquisa facial Ntechlab",
      search: "Pesquisar",
      change_search: "Mudar pesquisa",
      no_results_found: "Nenhum resultado encontrado",
      delete_image: "Deletar Imagem",
      full_image: "Imagem Completa",
    }
  }
};
